// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-credit-name[data-v-373824d6]{cursor:pointer;color:#78a6b8}.title-credit-name[data-v-373824d6]:hover{color:#d5d5d5}", ""]);
// Exports
module.exports = exports;
